const triggeredGoogleAnalyticsFields = require("./triggeredGoogleAnalyticsFields");

/**
 * @param fieldName {string}
 * @return {boolean}
 */
module.exports = function didTriggerGoogleAnalyticsForRoiCalculatorField(fieldName) {
    return fieldName in triggeredGoogleAnalyticsFields;
}